export const times = [
  { from: '3:00', to: '4:00' },
  { from: '5:00', to: '6:00' },
  { from: '6:00', to: '7:00' },
  { from: '7:00', to: '08:00' },
  { from: '8:00', to: '09:00' },
  { from: '9:00', to: '10:00' },
  { from: '10:00', to: '11:00' },
  { from: '11:00', to: '12:00' },
  { from: '12:00', to: '13:00' },
  { from: '13:00', to: '14:00' },
  { from: '14:00', to: '15:00' },
  { from: '15:00', to: '16:00' },
  { from: '16:00', to: '17:00' },
  { from: '17:00', to: '18:00' },
  { from: '18:00', to: '19:00' },
  { from: '19:00', to: '20:00' },
  { from: '20:00', to: '21:00' },
  { from: '21:00', to: '22:00' },
  { from: '22:00', to: '23:00' },
  { from: '23:00', to: '24:00' }
];

export const generateTimes = (from) => {
  const timeArray = [];
  const to = '24:00';
  for (let index = parseInt(from, 10) + 1; index <= parseInt(to, 10); index++) {
    const previousIndex = index - 1;
    const formattedFrom = `${previousIndex}:00`;
    const formattedIndex = `${index}:00`;
    timeArray.push({ from: formattedFrom, to: formattedIndex });
  }
  return timeArray;
};
